import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import Post from '~/components/feed/FeedPost.vue';
import Skeleton from '~/components/feed/FeedSkeleton.vue';
import Onboarding from '~/components/feed/FeedOnboarding.vue';
import Follow from "~/components/profile/Follow.vue";
import { useFeedStore } from '~/storeModules/useFeed.js';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
export default {
  props: ['query', 'feed', 'feedName', 'roomName'],
  components: {
    Post: Post,
    Skeleton: Skeleton,
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    Panel: function Panel() {
      return import('~/components/panels/CasesPanel.vue');
    },
    Comments: function Comments() {
      return import('~/components/comments/Comments.vue');
    },
    Share: function Share() {
      return import('~/components/share/ShareDropdown.vue');
    },
    Follow: Follow,
    Onboarding: Onboarding
  },
  data: function data() {
    return {
      limit: 10,
      fetching: false,
      initing: true,
      activePost: {},
      clearMinHeight: false,
      commentsPostId: null,
      commentsPostModel: null,
      commentsPanelName: "comments-".concat(this.feedName)
    };
  },
  computed: {
    feedStoreName: function feedStoreName() {
      return "feed/".concat(this.feedName);
    },
    feedStore: function feedStore() {
      return useFeedStore(this.feedStoreName);
    },
    feedsStore: function feedsStore() {
      return useFeedsStore();
    },
    minItemSize: function minItemSize() {
      var size = 532;
      if (this.$mq == 'xs') size = 544;
      if (this.$mq == 'sm') size = 445;
      return size;
    },
    length: function length() {
      var length = 0;
      if (this.feedStore) {
        length = this.feedStore.length;
      }
      return length;
    },
    minHeight: function minHeight() {
      var minHeight = 0;
      if (this.feedStore) {
        minHeight = this.feedStore.minHeight;
      }
      return minHeight;
    },
    prerender: function prerender() {
      if (this.minHeight) return 0;
      return this.length < 5 ? this.length : 5;
    },
    posts: function posts() {
      var posts = [];
      if (this.feedStore) {
        posts = this.feedStore.posts;
      }
      return posts;
    },
    computedPosts: function computedPosts() {
      return this.posts.map(function (post) {
        return {
          id: post.id,
          post: post,
          size: post.size || 0
        };
      });
    },
    news: function news() {
      var posts = [];
      if (this.feedStore) {
        posts = this.feedStore.new;
      }
      return posts;
    },
    queryParams: function queryParams() {
      return Object.assign({
        limit: this.limit
      }, this.query);
    },
    userCompanies: function userCompanies() {
      if (this.$auth.user && this.$auth.user) {
        return this.$auth.user.moders.map(function (o) {
          return o.company.id;
        });
      } else {
        return [];
      }
    },
    activePostLink: function activePostLink() {
      return "".concat(this.$axios.defaults.baseURL).concat(this.activePost.link);
    },
    isModer: function isModer() {
      return this.$auth.user && this.$auth.user.role.fullAccess;
    },
    canEdit: function canEdit() {
      if (!this.activePost || !this.$auth.user) return false;
      if (this.isModer) return true;
      if (this.activePost.authorModel == 'user') {
        return this.activePost.authorId == this.$auth.user.id;
      }
      if (this.activePost.authorModel == 'company') {
        return this.userCompanies.includes(this.activePost.authorId);
      }
    },
    canSubscribe: function canSubscribe() {
      return this.activePost.authorModel != 'user' || !this.$auth.user || this.activePost.authorId != this.$auth.user.id;
    },
    editLink: function editLink() {
      if (!this.activePost) return null;
      var link = "/".concat(this.activePost.modelName, "-editor/");
      if (this.activePost.modelName == 'publication') {
        return this.localePath("/editor/".concat(this.activePost.modelId));
      }
      return "".concat(link).concat(this.activePost.modelId);
    },
    modelType: function modelType() {
      var type = this.activePost.modelName;
      switch (this.activePost.modelName) {
        case 'publication':
          type = this.activePost.type;
          break;
        case 'column':
          type = 'article';
          break;
        case 'post':
          type = 'case';
          break;
      }
      return type;
    },
    profileStore: function profileStore() {
      return useProfileStore();
    }
  },
  created: function created() {
    this.feedsStore.addFeed(this.feedStoreName);
    if (!this.posts.length) {
      if (this.feed) {
        this.feedStore.join({
          posts: this.feed.posts,
          length: this.feed.length,
          roomName: this.roomName,
          query: this.query
        });
      } else {
        if (process.browser) return this.init();
        return;
      }
    }
    this.initing = false;
  },
  mounted: function mounted() {
    this.observe();
    document.addEventListener('scroll', this.hideProfileInformer);
  },
  methods: {
    openComments: function openComments(_ref) {
      var commentsPostId = _ref.commentsPostId,
        commentsPostModel = _ref.commentsPostModel;
      this.commentsPostId = commentsPostId;
      this.commentsPostModel = commentsPostModel;
      this.$modalityStore.openModal({
        type: 'drawer',
        name: this.commentsPanelName
      });
    },
    removeMinHeight: function removeMinHeight() {
      var _this = this;
      if (!process.browser) return;
      setTimeout(function () {
        _this.clearMinHeight = true;
      }, 100);
    },
    init: function init() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.fetching = true;
              _context.next = 3;
              return _this2.load(_this2.queryParams);
            case 3:
              data = _context.sent;
              _this2.feedStore.join({
                posts: data.posts,
                length: data.length,
                roomName: _this2.roomName,
                query: _this2.query
              });
              _this2.fetching = false;
              _this2.initing = false;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetch: function fetch() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this3.length == _this3.posts.length || _this3.fetching || _this3.initing)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this3.fetching = true;
              query = Object.assign(_this3.queryParams, {
                skip: _this3.posts.length
              });
              _context2.next = 6;
              return _this3.load(query);
            case 6:
              data = _context2.sent;
              _this3.feedStore.push(data.posts);
              _this3.fetching = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    load: function load(query) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var feedData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.$axios.$get('/feed/find', {
                params: query,
                progress: false
              }).catch(function (err) {
                return console.error(err);
              });
            case 2:
              feedData = _context3.sent;
              return _context3.abrupt("return", feedData);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    observe: function observe() {
      var _this5 = this;
      var scrollTopThreshold = 0.3;
      this.introObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = entry.isIntersecting && entry.intersectionRatio >= scrollTopThreshold;
          if (visible) _this5.fetch();
        });
      }, {
        root: null,
        rootMargin: "0px 0px 600px 0px",
        threshold: scrollTopThreshold
      });
      var endBlock = this.$refs.feedend;
      if (endBlock) this.introObserver.observe(endBlock);
    },
    unobserve: function unobserve() {
      if (this.introObserver) this.introObserver.disconnect();
    },
    showNew: function showNew() {
      var _this6 = this;
      this.$scrollTo("body", {
        offset: -100,
        onDone: function onDone() {
          _this6.feedStore.showNew();
        }
      });
    },
    setActivePost: function setActivePost(post) {
      if (post.id !== this.activePost.id) this.activePost = post;
    },
    copyUrl: function copyUrl() {
      var inp = document.createElement('input'),
        text = this.activePostLink;
      document.body.appendChild(inp);
      inp.value = text;
      inp.select();
      document.execCommand('copy');
      document.body.removeChild(inp);
      this.$toastStore.add({
        text: this.$t('toast.linkCopied'),
        closable: true,
        icon: 'icon-ic-link'
      });
    },
    toggleFavorite: function toggleFavorite() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var error, clone, model, id, inEditorsChoice, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!_this7.activePost || !_this7.isModer)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", true);
            case 2:
              error = null;
              clone = Object.assign({}, _this7.activePost);
              model = _this7.activePost.modelName;
              id = _this7.activePost.modelId;
              inEditorsChoice = _this7.activePost.editorsChoice; // Immidiate response
              _this7.feedsStore.updatePosts({
                ids: [id],
                update: {
                  editorsCoice: !inEditorsChoice
                }
              });
              _context4.next = 10;
              return _this7.$axios.$post("/".concat(model, "-toggleeditorschoice/").concat(id)).catch(function (e) {
                error = e;
              });
            case 10:
              data = _context4.sent;
              if (error) {
                console.error(error);
                _this7.$toastStore.add({
                  title: 'Не вдалось змінити параметр Вибір редакції',
                  text: "\u041C\u0430\u0442\u0435\u0440\u0456\u0430\u043B: ".concat(clone.title, ". \u041F\u043E\u0434\u0440\u043E\u0431\u0438\u0446\u0456 \u0432\u0438\u0432\u0435\u0434\u0435\u043D\u043E \u0432 \u043A\u043E\u043D\u0441\u043E\u043B\u044C."),
                  icon: 'icon-ic-dismiss',
                  autoClose: false
                });

                // Set back state back
                _this7.feedsStore.updatePosts({
                  ids: [id],
                  update: {
                    editorsCoice: inEditorsChoice
                  }
                });
              }
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    hide: function hide() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var error, clone, title, url, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!_this8.canEdit || !_this8.activePost)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              error = null;
              clone = Object.assign({}, _this8.activePost);
              title = clone.title || _this8.$t('general.untitled');
              if (window.confirm(_this8.$t("".concat(_this8.modelType, ".confirmHide"), {
                title: title
              }))) {
                _context5.next = 7;
                break;
              }
              return _context5.abrupt("return");
            case 7:
              // Immidiate response
              _this8.feedsStore.updatePosts({
                ids: [clone.id],
                update: {
                  deleted: true
                }
              });
              _this8.$modalityStore.closeDropdown({
                name: 'actions-feed-post'
              });
              url = "/".concat(clone.modelName, "-hide/").concat(clone.modelId);
              if (clone.modelName == 'publication') {
                url = "/publication/draft/".concat(clone.modelId);
              }
              _context5.next = 13;
              return _this8.$axios.$post(url).catch(function (err) {
                return error = err;
              });
            case 13:
              data = _context5.sent;
              if (error) {
                console.error(error);
                _this8.$toastStore.add({
                  title: _this8.$t("".concat(_this8.modelType, ".hideErrorTitle")),
                  text: _this8.$t("".concat(_this8.modelType, ".hideErrorText")),
                  icon: 'icon-ic-eye-strike'
                });

                // Set state back
                _this8.feedsStore.updatePosts({
                  ids: [clone.id],
                  update: {
                    deleted: false
                  }
                });
              }
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    remove: function remove() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var error, clone, title, url, data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(!_this9.canEdit || !_this9.activePost)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              error = null;
              clone = Object.assign({}, _this9.activePost);
              title = clone.title || _this9.$t('general.untitled');
              if (window.confirm(_this9.$t("".concat(_this9.modelType, ".confirmDelete"), {
                title: title
              }))) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return");
            case 7:
              // Immidiate response
              _this9.feedsStore.updatePosts({
                ids: [clone.id],
                update: {
                  deleted: true
                }
              });
              _this9.$modalityStore.closeDropdown({
                name: 'actions-feed-post'
              });
              url = "/".concat(clone.modelName, "-destroy/").concat(clone.modelId);
              if (clone.modelName == 'publication') {
                url = "/publication/destroy/".concat(clone.modelId);
              }
              _context6.next = 13;
              return _this9.$axios.$post(url).catch(function (err) {
                return error = err;
              });
            case 13:
              data = _context6.sent;
              if (error) {
                console.error(error);
                _this9.$toastStore.add({
                  title: _this9.$t("".concat(_this9.modelType, ".deleteErrorTitle")),
                  text: _this9.$t("".concat(_this9.modelType, ".deleteErrorText")),
                  icon: 'icon-ic-bin'
                });

                // Set state back
                _this9.feedsStore.updatePosts({
                  ids: [clone.id],
                  update: {
                    deleted: false
                  }
                });
              }
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    saveSize: function saveSize(id) {
      var _this10 = this;
      this.$nextTick(function () {
        var index = _this10.posts.findIndex(function (o) {
          return o.id == id;
        });
        if (_this10.$refs.scroller) {
          var size = _this10.$refs.scroller.$refs.scroller.sizes[index].size;
          if (size) {
            _this10.feedsStore.updatePosts({
              ids: [id],
              update: {
                size: size
              }
            });
          }
        }
      });
    },
    expand: function expand(id) {
      if (this.$refs.scroller) this.$refs.scroller.clearSizeCache();
    },
    hideProfileInformer: function hideProfileInformer() {
      var ddName = this.profileStore.ddName;
      this.$modalityStore.closeDropdown({
        name: ddName
      });
      this.profileStore.continue();
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Save min height
    if (this.$refs.scroller) {
      this.feedStore.setMinHeight(this.$refs.scroller.$refs.scroller.totalSize + 200);
    }
  },
  destroyed: function destroyed() {
    this.unobserve();
    document.removeEventListener('scroll', this.hideProfileInformer);
  }
};